// About Us — Native & Collection CRO injector (2026-06-21)
// Targets:
//   - /products/native-hoodie-*     (Native PDP: BOGO, trust list, spec block, banners)
//   - /collections/native           (Native collection: trust image + campaign banner)
//   - /collections/hoodies          (Hoodies collection: trust image + campaign banner)
//   - /collections/elements*        (Elements collection: trust image + campaign banner)
//
// BRAND GUARDRAIL — Native must NEVER publicly state cotton %, blend ratio, or GSM
// (internal only: 50/50 cotton/poly, 430gsm). The 460gsm / 100% cotton copy is
// brand-safe ONLY on Elements. This spec block uses Native-safe facts only.
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  var isNativePDP = /\/products\/native-hoodie/i.test(location.pathname);
  var isNativeCollection = /\/collections\/(native|hoodies|elements)/i.test(location.pathname);
  if (!isNativePDP && !isNativeCollection) return;
  if (window.__auNativeCroLoaded) return;
  window.__auNativeCroLoaded = true;

  var BRAND_NAVY = '#131936';
  var BRAND_MILK = '#F4F1EA';
  var FONT_BODY = "'Raleway', 'Helvetica Neue', sans-serif";
  var FONT_DISPLAY = "'Unbounded', 'Helvetica Neue', sans-serif";

  // ── Shared style injection ─────────────────────────────────────────────────
  var style = document.createElement('style');
  style.textContent = [
    // Disable product card hover image swap — block pointer events on the slideshow-component
    // so Horizon's JS never sees mouseenter/mouseleave on the grid cards
    'ul.product-grid slideshow-component{pointer-events:none!important;}',
    'ul.product-grid slideshow-component *{pointer-events:none!important;}',
    // Belt-and-suspenders: hide the second slide and freeze the track transform
    'slideshow-slide.product-media-container~slideshow-slide.product-media-container{display:none!important;}',
    '.card__media-second{display:none!important;}',
    'ul.product-grid slideshow-component [class*="track"]{transform:none!important;transition:none!important;}',
    // Force uniform 4:5 portrait aspect ratio on all collection grid cards (fixes size inconsistency)
    'ul.product-grid slideshow-slide.product-media-container{display:block!important;aspect-ratio:4/5!important;overflow:hidden!important;}',
    'ul.product-grid slideshow-slide.product-media-container img{width:100%!important;height:100%!important;object-fit:cover!important;object-position:center top!important;}',
    // Female clone cards: pull back to center so close-up portraits show more body
    'ul.product-grid [data-au-female="1"] slideshow-slide.product-media-container img{object-position:center 20%!important;}',
    // Force BOGO/custom-liquid hero sections to full bleed (IDs contain __hero_)
    '[id*="__hero_"] .page-width{max-width:none!important;padding-left:0!important;padding-right:0!important;}',
    '.au-bogo-line{',
      'font-family:' + FONT_BODY + ';',
      'font-size:14px;color:' + BRAND_NAVY + ';',
      'margin:10px 0 14px;line-height:1.5;',
    '}',
    '.au-trust-list{',
      'list-style:none;padding:0;margin:0 0 18px;',
    '}',
    '.au-trust-list li{',
      'font-family:' + FONT_BODY + ';',
      'font-size:13px;color:rgba(19,25,54,0.72);',
      'padding:3px 0;line-height:1.5;',
    '}',
    '.au-native-spec{',
      'padding:28px 0 8px;border-top:1px solid rgba(19,25,54,0.1);margin-top:28px;',
    '}',
    '.au-native-spec__heading{',
      'font-family:' + FONT_DISPLAY + ';',
      'font-size:12px;font-weight:700;',
      'color:' + BRAND_NAVY + ';letter-spacing:0.06em;',
      'text-transform:uppercase;margin:0 0 18px;line-height:1.4;',
    '}',
    '.au-native-spec__table{width:100%;border-collapse:collapse;}',
    '.au-native-spec__table td{',
      'font-family:' + FONT_BODY + ';',
      'font-size:13px;color:' + BRAND_NAVY + ';',
      'padding:9px 0;border-bottom:1px solid rgba(19,25,54,0.08);',
      'line-height:1.5;vertical-align:top;',
    '}',
    '.au-native-spec__table td:first-child{',
      'color:rgba(19,25,54,0.52);width:48%;padding-right:12px;',
    '}',
    '.au-bloom-pdp-removed{display:none !important;}',
  ].join('');
  document.head.appendChild(style);

  // ── DOM helpers ───────────────────────────────────────────────────────────
  function qs(selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function insertAfter(newNode, refNode) {
    if (refNode && refNode.parentNode) {
      refNode.parentNode.insertBefore(newNode, refNode.nextSibling);
      return true;
    }
    return false;
  }

  function insertBefore(newNode, refNode) {
    if (refNode && refNode.parentNode) {
      refNode.parentNode.insertBefore(newNode, refNode);
      return true;
    }
    return false;
  }

  var LARGE_BANNER_URL = 'https://cdn.shopify.com/s/files/1/0586/2414/7541/files/LARGE_BANNER-02_749217b9-ff4b-4915-ad8d-c16dd73e18d4.jpg?v=1755331645';
  var KIVE_46_URL = 'https://cdn.shopify.com/s/files/1/0586/2414/7541/files/Generated_with_Kive.ai_-_kive-image_46.jpg?v=1782014657';

  function injectLargeBanner(afterEl) {
    if (document.getElementById('au-native-large-banner')) return;
    var wrap = document.createElement('div');
    wrap.id = 'au-native-large-banner';
    wrap.style.cssText = 'width:100%;line-height:0;font-size:0;margin:0;padding:0;';
    var img = document.createElement('img');
    img.src = LARGE_BANNER_URL;
    img.alt = 'Native — About Us The Label';
    img.style.cssText = 'width:100%;display:block;height:auto;';
    wrap.appendChild(img);
    if (afterEl && afterEl.parentNode) {
      afterEl.parentNode.insertBefore(wrap, afterEl.nextSibling);
    } else {
      document.body.appendChild(wrap);
    }
  }

  // Brand trust BTS photo — goes at the bottom of every page this script targets
  function injectTrustImage(afterEl) {
    if (document.getElementById('au-native-trust-image')) return;
    var wrap = document.createElement('div');
    wrap.id = 'au-native-trust-image';
    wrap.style.cssText = 'width:100%;line-height:0;font-size:0;margin:0;padding:0;';
    var img = document.createElement('img');
    img.src = KIVE_46_URL;
    img.alt = 'About Us The Label — Behind the brand';
    img.style.cssText = 'width:100%;display:block;height:auto;';
    wrap.appendChild(img);
    if (afterEl && afterEl.parentNode) {
      afterEl.parentNode.insertBefore(wrap, afterEl.nextSibling);
    } else {
      document.body.appendChild(wrap);
    }
  }

  // Duplicate each product card to show the female/alternate model shot (second product image)
  // Grid uses ul.product-grid with product-card-link custom elements (Horizon theme)
  function injectFemaleCards() {
    var grid = document.querySelector('ul.product-grid');
    if (!grid || !grid.children.length) return;
    var items = Array.from(grid.children).filter(function(el) {
      return !el.getAttribute('data-au-female');
    });
    if (!items.length) return;
    items.forEach(function(item) {
      var slides = item.querySelectorAll('slideshow-slide.product-media-container');
      if (!slides || slides.length < 2) return;
      var secondImg = slides[1].querySelector('img');
      if (!secondImg) return;
      var src2 = secondImg.getAttribute('src');
      var srcset2 = secondImg.getAttribute('srcset') || '';
      var alt2 = secondImg.getAttribute('alt') || '';
      if (!src2) return;
      // Skip non-portrait 2nd images (rack shots, flat lays) — only inject female cards for model shots
      var nw = secondImg.naturalWidth || secondImg.width;
      var nh = secondImg.naturalHeight || secondImg.height;
      if (nw > 0 && nh > 0 && nh / nw < 0.85) return;
      var clone = item.cloneNode(true);
      clone.setAttribute('data-au-female', '1');
      var cloneSlides = clone.querySelectorAll('slideshow-slide.product-media-container');
      var firstImg = cloneSlides[0] && cloneSlides[0].querySelector('img');
      if (firstImg) {
        firstImg.setAttribute('src', src2);
        if (srcset2) firstImg.setAttribute('srcset', srcset2);
        firstImg.setAttribute('alt', alt2);
      }
      for (var i = 1; i < cloneSlides.length; i++) { cloneSlides[i].style.display = 'none'; }
      grid.insertBefore(clone, item.nextSibling);
    });
  }

  // Disable hover-swap on all slideshow-components inside the product grid.
  // Strategy:
  // (1) Patch prototype.goToSlide to no-op for grid cards (catches direct JS calls)
  // (2) MutationObserver on each track element — instantly resets transform to 0
  //     whenever Horizon's JS tries to slide it. Faster than any CSS transition.
  // (3) CSS already sets transition:none + transform:none as belt-and-suspenders.
  // NOTE: cloneNode is NOT used — it triggers connectedCallback on custom elements
  //       which re-attaches Horizon's own event listeners.
  function freezeGridSlideshows() {
    // Patch prototype
    var SlideshowCls = customElements && customElements.get && customElements.get('slideshow-component');
    if (SlideshowCls && SlideshowCls.prototype) {
      var orig = SlideshowCls.prototype.goToSlide;
      SlideshowCls.prototype.goToSlide = function() {
        if (this.closest('ul.product-grid')) return;
        if (orig) return orig.apply(this, arguments);
      };
      // Also patch common aliases Horizon may use
      ['next','previous','setSlide','showSlide'].forEach(function(m) {
        if (typeof SlideshowCls.prototype[m] === 'function') {
          var o = SlideshowCls.prototype[m];
          SlideshowCls.prototype[m] = function() {
            if (this.closest('ul.product-grid')) return;
            return o.apply(this, arguments);
          };
        }
      });
    }

    // MutationObserver per slideshow-component — watch style changes on the track
    document.querySelectorAll('ul.product-grid slideshow-component').forEach(function(ss) {
      // Horizon's track element is a direct child container (ul/div/ol)
      // Also watch the slideshow-component itself for attribute changes
      function lockTransform(el) {
        if (!el) return;
        if (el.style.transform && el.style.transform !== 'translateX(0px)' && el.style.transform !== 'none') {
          el.style.setProperty('transform', 'translateX(0px)', 'important');
          el.style.setProperty('transition', 'none', 'important');
        }
      }
      var children = Array.from(ss.children);
      children.concat([ss]).forEach(function(el) {
        lockTransform(el);
        new MutationObserver(function() { lockTransform(el); })
          .observe(el, { attributes: true, attributeFilter: ['style', 'class'] });
      });
    });
  }

  // Wait for ul.product-grid to be populated (Horizon renders it after DOMContentLoaded)
  function waitForGridAndInjectFemaleCards() {
    var grid = document.querySelector('ul.product-grid');
    if (grid && grid.children.length > 0) {
      injectFemaleCards();
      setTimeout(freezeGridSlideshows, 200);
      return;
    }
    var obs = new MutationObserver(function(_, observer) {
      var g = document.querySelector('ul.product-grid');
      if (g && g.children.length > 0) {
        observer.disconnect();
        setTimeout(function() { injectFemaleCards(); setTimeout(freezeGridSlideshows, 200); }, 150);
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function() { obs.disconnect(); }, 10000);
  }

  function init() {
    // ── Collection pages (native / hoodies / elements) ────────────────────────
    if (isNativeCollection) {
      // Find last shopify-section (excluding footer) as anchor
      var allSections = Array.from(document.querySelectorAll('[id^="shopify-section-"]:not([id*="footer"])'));
      var lastShopSection = allSections.length ? allSections[allSections.length - 1] : document.body;

      // Show both male + female model cards side by side in the grid
      waitForGridAndInjectFemaleCards();

      // Brand trust BTS image immediately after last theme section
      injectTrustImage(lastShopSection);

      // Large campaign banner after trust image
      var trustEl = document.getElementById('au-native-trust-image');
      injectLargeBanner(trustEl || lastShopSection);

      // Remove Bloom coming-soon banner on collection pages too
      var bloomSels = ['[class*="bloom"]','[id*="bloom"]','[data-section-type*="bloom"]'];
      bloomSels.forEach(function(sel) {
        document.querySelectorAll(sel).forEach(function(el) {
          var txt = (el.textContent || '').toLowerCase();
          if (txt.includes('coming soon') || txt.includes('bloom range') || txt.includes('bloom —') || txt.includes('arriving')) {
            el.classList.add('au-bloom-pdp-removed');
          }
        });
      });
      return;
    }

    // ── Native PDP ─────────────────────────────────────────────────────────────

    // 1. BOGO offer line — inject after the price element
    var priceEl = qs([
      'product-price',
      'span.regular-price',
      '.product__price',
      '.price__regular',
      '.price-item--regular',
      '[class*="product-price"]',
      '.product-single__price',
      'price-money',
      '.price',
    ]);
    if (priceEl) {
      var priceContainer = priceEl;
      var tag0 = priceContainer.tagName.toLowerCase();
      if (tag0 !== 'product-price' && tag0 !== 'div' && tag0 !== 'p' && tag0 !== 'section') {
        for (var depth = 0; depth < 4; depth++) {
          var parent = priceContainer.parentElement;
          if (!parent) break;
          var tag = parent.tagName.toLowerCase();
          if (tag === 'div' || tag === 'p' || tag === 'section' || tag === 'form' || tag === 'product-price') break;
          priceContainer = parent;
        }
      }
      var bogoEl = document.createElement('p');
      bogoEl.className = 'au-bogo-line';
      bogoEl.textContent = 'Every hoodie comes with your choice of tee. Worn together, checked out once.';
      insertAfter(bogoEl, priceContainer);
    }

    // 2. Trust/risk-reversal block — above the ATC button
    var atcBtn = qs([
      'button[name="add"]',
      '.product-form__submit',
      '[data-testid="Checkout-button"]',
      'form[action*="/cart/add"] button[type="submit"]',
      '.btn--add-to-cart',
    ]);
    if (atcBtn) {
      var trustEl = document.createElement('ul');
      trustEl.className = 'au-trust-list';
      trustEl.innerHTML = [
        '<li>&#x2713; Complimentary shipping Australia-wide</li>',
        '<li>&#x2713; 30-day returns, no questions</li>',
        '<li>&#x2713; Premium tee included</li>',
      ].join('');
      var atcWrap = atcBtn.closest('.product-form__buttons, .product-form__cart, [class*="buy-buttons"]') || atcBtn;
      insertBefore(trustEl, atcWrap);
    }

    // 3. Spec block — Native-safe facts only (NO gsm, NO cotton/blend claims)
    var specTarget = qs([
      '.product__description',
      '.product-single__description',
      '[class*="product-description"]',
      '.rte',
    ]);
    if (specTarget) {
      var specEl = document.createElement('div');
      specEl.className = 'au-native-spec';
      specEl.innerHTML = [
        '<h3 class="au-native-spec__heading">Recovery wear, made like outerwear. Here\'s the spec.</h3>',
        '<table class="au-native-spec__table"><tbody>',
          '<tr><td>Fabric</td><td>Premium heavyweight fleece</td></tr>',
          '<tr><td>Interior</td><td>Brushed</td></tr>',
          '<tr><td>Drape</td><td>Structured, built for stillness</td></tr>',
          '<tr><td>Designed</td><td>Melbourne</td></tr>',
          '<tr><td>Set</td><td>Your choice of tee, checked out once</td></tr>',
        '</tbody></table>',
      ].join('');
      specTarget.appendChild(specEl);
    }

    // 4. Large campaign banner at the very bottom of the PDP
    var lastPdpSection = document.querySelector('[id^="shopify-section-template"]:last-of-type')
      || document.querySelector('main > :last-child');
    injectLargeBanner(lastPdpSection);

    // 5. Close-ups detail banner — full-width strip below the product section
    var CLOSEUPS_BANNER_URL = 'https://cdn.shopify.com/s/files/1/0586/2414/7541/files/native-closeups-banner.jpg?v=1782011563';
    var productSection = qs([
      '[id*="shopify-section"][id*="product-information"]',
      '[id*="shopify-section"][id*="product_information"]',
      '.shopify-section--product-information',
      '[data-section-type="product-information"]',
    ]);
    var bannerInsertTarget = productSection
      ? productSection
      : (document.querySelector('[id^="shopify-section-template"]') || null);
    if (bannerInsertTarget && !document.getElementById('au-native-closeups-banner')) {
      var bannerWrap = document.createElement('div');
      bannerWrap.id = 'au-native-closeups-banner';
      bannerWrap.style.cssText = [
        'width:100%;overflow:hidden;',
        'line-height:0;font-size:0;',
        'margin:0;padding:0;',
        'background:#131936;',
      ].join('');
      var bannerImg = document.createElement('img');
      bannerImg.src = CLOSEUPS_BANNER_URL;
      bannerImg.alt = 'Native hoodie — fabric detail';
      bannerImg.style.cssText = 'width:100%;display:block;height:auto;max-height:420px;object-fit:cover;object-position:center;';
      bannerWrap.appendChild(bannerImg);
      insertAfter(bannerWrap, bannerInsertTarget);
    }

    // 6. Brand trust BTS image — after lifestyle (au_fabric_band) so lifestyle sits above BTS
    var fabricBandEl = document.querySelector('[id*="au_fabric_band"]');
    var closeupsEl = document.getElementById('au-native-closeups-banner');
    var pdpTrustTarget = fabricBandEl || closeupsEl || bannerInsertTarget || lastPdpSection;
    injectTrustImage(pdpTrustTarget);

    // 7. Swap feature-diagram image (Ink hoodie diagram → Native hoodie diagram)
    var diagSection = document.querySelector('[id*="feature_diagram_hero"]');
    if (diagSection) {
      var diagImg = diagSection.querySelector('img');
      if (diagImg) {
        var NEW_DIAGRAM = 'https://cdn.shopify.com/s/files/1/0586/2414/7541/files/Shopify_Banners_-_Native_Hoodie_Diagram.png?v=1782011904';
        diagImg.src = NEW_DIAGRAM;
        diagImg.srcset = '';
        diagImg.removeAttribute('srcset');
        if (diagImg.parentElement && diagImg.parentElement.tagName === 'PICTURE') {
          Array.from(diagImg.parentElement.querySelectorAll('source')).forEach(function(s) { s.remove(); });
        }
      }
    }

    // 8. Remove inline Bloom coming-soon banner if it renders on the Native PDP
    var bloomSelectors = [
      '[class*="bloom"]',
      '[id*="bloom"]',
      '[data-section-type*="bloom"]',
    ];
    bloomSelectors.forEach(function(sel) {
      var existing = document.querySelectorAll(sel);
      existing.forEach(function(el) {
        var text = (el.textContent || '').toLowerCase();
        if (text.includes('coming soon') || text.includes('bloom range') || text.includes('bloom —') || text.includes('arriving')) {
          el.classList.add('au-bloom-pdp-removed');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
